import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  deleteRecordingImage,
  getRecordingImages,
  patchRecordingImageKind,
  type RecordingImageKind,
} from './recordingImageApi'

export const recordingImagesKey = (yakurekiId: string) =>
  ['recording-images', yakurekiId] as const

// 添付写真の一覧取得 (query) + 種別の変更/削除 (mutation)。送るのは記録ごとの置き場 (attachmentUploads)。event polling とは独立した
// 専用 query にして、アップロード直後に自身だけを invalidate する (poll 周期に依存しない)。
export const useRecordingImages = (yakurekiId: string | null) => {
  const queryClient = useQueryClient()

  const list = useQuery({
    queryKey: recordingImagesKey(yakurekiId ?? ''),
    queryFn: () => getRecordingImages(yakurekiId!),
    enabled: !!yakurekiId,
    staleTime: 30_000,
  })

  // 一覧を引き直し終えるまで mutation を終えない
  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: recordingImagesKey(yakurekiId ?? ''),
    })

  const changeKind = useMutation({
    mutationFn: ({
      imageId,
      kind,
    }: {
      imageId: string
      kind: RecordingImageKind
    }) => patchRecordingImageKind(yakurekiId!, imageId, kind),
    onSuccess: invalidate,
  })

  const remove = useMutation({
    mutationFn: (imageId: string) => deleteRecordingImage(yakurekiId!, imageId),
    onSuccess: invalidate,
  })

  return { list, changeKind, remove }
}
